(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  define('pricelist/views/NodesView',["jquery", "backbone", "pricelist/collections/Nodes", "pricelist/views/NodeView", "pricelist/views/NodeHeaderView"], function($, Backbone, Nodes, NodeView, NodeHeaderView) {
    var View, collapseCounter, previousLayout;
    collapseCounter = 0;
    previousLayout = "";
    return View = (function(superClass) {
      extend(View, superClass);

      function View() {
        return View.__super__.constructor.apply(this, arguments);
      }

      View.prototype.tagName = "div";

      View.prototype.className = "node-list";

      View.prototype.initialize = function() {
        var i, id, item, key, len, price, ref;
        this.wholeLayout = this.options.wholeLayout;
        this.currentLayout = this.options.layout[0];
        this.counter = 0;
        if (this.options.resetCollapseCounter) {
          collapseCounter = 0;
        }
        key = this.keyForLayout();
        this.collection = new Nodes(this.options[key.name]);

        /* Builds an object which id properties, each property represents an id and each property holds an array of prices. */
        if (!this.isPrice() && this.options.prices) {
          this.build = [];
          ref = this.options.prices;
          for (i = 0, len = ref.length; i < len; i++) {
            price = ref[i];
            id = price[key.id];
            item = _.find(this.build, function(item) {
              return item.id === id;
            });
            if (!item) {
              item = {
                id: price[key.id],
                serial: this.collection.get(id).get("Serial"),
                prices: []
              };
              this.build.push(item);
            }
            item.prices.push(price);
          }
          return this.build = _.sortBy(this.build, function(item) {
            return item.serial;
          });
        }
      };

      View.prototype.render = function() {
        var flattenedNodesCounter;
        if (this.options.flattenHeader.start === this.currentLayout) {
          this.renderHeader();
        }
        if (this.isPrice()) {
          this.renderPrices();
        } else {
          if (this.wholeLayout.toLowerCase().indexOf("v") < 0 && this.currentLayout.toLowerCase() === "f") {
            this.addCollapsablePanel();
          } else if (this.currentLayout.toLowerCase() === "v") {
            this.addCollapsablePanel();
          }
          flattenedNodesCounter = 1;
          _.each(this.build, (function(_this) {
            return function(item) {
              if (_this.currentLayout.toLowerCase() === _this.currentLayout) {
                _this.renderFlattenedNodes(item.id, item.prices);
                return flattenedNodesCounter++;
              } else {
                return _this.renderNodes(item.id, item.prices);
              }
            };
          })(this));
        }
        return this;
      };

      View.prototype.addCollapsablePanel = function() {
        this.$el.attr("id", "collapse" + collapseCounter);
        this.$el.attr("role", "tabpanel");
        if (collapseCounter === 0) {
          return this.$el.addClass("collapse");
        } else {
          return this.$el.addClass("collapse in");
        }
      };

      View.prototype.renderHeader = function() {
        return this.$el.append((new NodeHeaderView({
          headerLayout: this.options.flattenHeader
        })).render().$el);
      };

      View.prototype.renderPrices = function() {
        return this.collection.each((function(_this) {
          return function(price, index) {
            var colorType;
            colorType = price.get("Colors").toString();
            return _this.$el.addClass(_this.flatten() + " size-" + _this.options.flattenHeader.visiblePrices.length).append((new NodeView({
              model: price,
              wholeLayout: _this.options.wholeLayout,
              layout: _this.options.layout,
              padding: $.inArray(colorType, _this.options.flattenHeader.visiblePrices) + 1
            })).render().$el);
          };
        })(this));
      };

      View.prototype.renderFlattenedNodes = function(id, prices) {
        var $container, model;
        model = this.collection.get(id);
        if (model == null) {
          this.debugNode(id);
        }
        $container = $("<div>", {
          "class": "node-container",
          attr: {
            "data-id": prices[0].Id
          }
        });
        $container.append((new NodeView({
          model: model,
          wholeLayout: this.wholeLayout,
          layout: this.currentLayout
        })).render().$el);
        $container.append((new View({
          wholeLayout: this.options.wholeLayout,
          layout: this.options.layout.slice(1, +this.options.layout.length + 1 || 9e9),
          previousLayout: this.currentLayout,
          flattenHeader: this.options.flattenHeader,
          sections: this.options.sections,
          positions: this.options.positions,
          formats: this.options.formats,
          variants: this.options.variants,
          weekdays: this.options.weekdays,
          comments: this.options.comments,
          prices: prices
        })).render().el);
        return this.$el.addClass(this.flatten()).append($container);
      };

      View.prototype.renderNodes = function(id, prices) {
        var model;
        model = this.collection.get(id);
        if (model == null) {
          this.debugNode(id);
        }
        this.$el.append((new NodeView({
          model: model,
          wholeLayout: this.wholeLayout,
          layout: this.currentLayout,
          variants: this.options.variants,
          collapseCounter: collapseCounter
        })).render().$el);
        if (this.currentLayout === "S") {
          this.counter++;
          if (model.get("Name") !== "Oberoende avdelning") {
            this.counter++;
          }
        }
        this.$el.addClass(this.flatten()).append((new View({
          wholeLayout: this.options.wholeLayout,
          layout: this.options.layout.slice(1, +this.options.layout.length + 1 || 9e9),
          previousLayout: this.currentLayout,
          flattenHeader: this.options.flattenHeader,
          sections: this.options.sections,
          positions: this.options.positions,
          formats: this.options.formats,
          variants: this.options.variants,
          weekdays: this.options.weekdays,
          comments: this.options.comments,
          prices: prices
        })).render().el);
        if (this.currentLayout.toLowerCase() === "s") {
          return collapseCounter++;
        } else if (this.currentLayout.toLowerCase() === "p") {
          return collapseCounter++;
        }
      };

      View.prototype.isPrice = function() {
        return this.currentLayout === "R" || this.currentLayout === "r";
      };

      View.prototype.isVariant = function() {
        return this.currentLayout === "I" || this.currentLayout === "i";
      };

      View.prototype.flatten = function() {
        if (this.currentLayout.toLowerCase() === this.currentLayout) {
          return "flatten";
        }
        return "";
      };

      View.prototype.keyForLayout = function() {
        switch (this.currentLayout) {
          case "S":
          case "s":
            return {
              id: "MediaSectionId",
              name: "sections"
            };
          case "P":
          case "p":
            return {
              id: "MediaPositionId",
              name: "positions"
            };
          case "F":
          case "f":
            return {
              id: "MediaFormatId",
              name: "formats"
            };
          case "V":
          case "v":
            return {
              id: "PriceVariantId",
              name: "variants"
            };
          case "I":
          case "i":
            return {
              id: "WeekdayId",
              name: "weekdays"
            };
          case "C":
          case "c":
            return {
              id: "CommentId",
              name: "comments"
            };
          case "R":
          case "r":
            return {
              id: "Id",
              name: "prices"
            };
          default:
            return null;
        }
      };

      View.prototype.debugNode = function(id) {
        var name;
        name = this.keyForLayout().id.replace("Id", "");
        return console.log("Missing " + name + " with id: " + id);
      };

      return View;

    })(Backbone.View);
  });

}).call(this);

//# sourceMappingURL=NodesView.js.map
;
